import React from "react";

class Fundraising extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <React.Fragment>
        <section className="section">
          <div className="container">
            <h1 className="title"> Fundraising Events </h1>
            <div className="columns">
              <div className="column">
                <div className="box has-background-white content">
                  <p className="subtitle">ANRC RAFFLE 3 NIGHT STAY WITH 2 FULL REGISTRATIONS</p>
                  <img src="img/ANRC2026RAFFLEQRCODE.png" height="250px" width="250px" alt="ANRC Raffle QR Code" />
                  <p ><a target="_blank" rel="noreferrer"  href="http://go.rallyup.com/anrc2026/Campaign/Details" >http://go.rallyup.com/anrc2026/Campaign/Details</a></p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Fundraising;
